import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b46f6b66"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "width": "90%",
    "margin-left": "5%"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "float": "right"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "col_bblue"
};
const _hoisted_4 = {
  key: 1,
  class: "col_bblue"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "flex-direction": "column"
  }
};
const _hoisted_8 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "flex-wrap": "wrap",
    "margin": "10px 0"
  }
};
const _hoisted_9 = {
  class: "option",
  style: {
    "line-height": "28px",
    "word-break": "break-all",
    "text-align": "left"
  }
};
const _hoisted_10 = {
  key: 0,
  style: {
    "background": "rgb(245,247,250)",
    "width": "30px",
    "height": "30px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5px",
    "border-radius": "4px"
  }
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-picture-outline",
  style: {
    "font-size": "14px",
    "color": "#d7d7d7"
  }
}, null, -1));

const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = {
  key: 1,
  style: {
    "display": "flex",
    "flex-wrap": "wrap"
  }
};
const _hoisted_14 = {
  key: 1,
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "align-items": "center"
  }
};
const _hoisted_15 = {
  class: "option",
  style: {
    "line-height": "28px",
    "word-break": "break-all",
    "text-align": "left"
  }
};
const _hoisted_16 = {
  key: 0,
  style: {
    "background": "rgb(245,247,250)",
    "width": "30px",
    "height": "30px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5px",
    "border-radius": "4px"
  }
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-picture-outline",
  style: {
    "font-size": "14px",
    "color": "#d7d7d7"
  }
}, null, -1));

const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = {
  key: 1,
  style: {
    "display": "flex",
    "flex-wrap": "wrap"
  }
};
const _hoisted_20 = {
  key: 1,
  style: {
    "color": "rgb(126,127,134)",
    "margin-left": "30px"
  }
};
const _hoisted_21 = {
  key: 2,
  style: {
    "color": "rgb(126,127,134)",
    "margin-left": "30px"
  }
};
const _hoisted_22 = {
  key: 1
};
const _hoisted_23 = {
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "flex-direction": "column"
  }
};
const _hoisted_24 = {
  style: {
    "display": "flex",
    "margin": "10px 0",
    "flex-direction": "column"
  }
};
const _hoisted_25 = {
  key: 0,
  style: {
    "background": "rgb(245,247,250)",
    "width": "30px",
    "height": "30px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5px",
    "border-radius": "4px"
  }
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-picture-outline",
  style: {
    "font-size": "14px",
    "color": "#d7d7d7"
  }
}, null, -1));

const _hoisted_27 = [_hoisted_26];
const _hoisted_28 = {
  key: 1,
  style: {
    "display": "flex",
    "flex-wrap": "wrap"
  }
};
const _hoisted_29 = {
  key: 2,
  style: {
    "margin": "20px 0 0 10px",
    "color": "#D9001B",
    "display": "flex"
  }
};

const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "white-space": "nowrap",
    "margin-right": "20px"
  }
}, " 补充备注: ", -1));

const _hoisted_31 = {
  style: {
    "margin-left": "10px",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_32 = {
  style: {
    "white-space": "nowrap",
    "margin-right": "20px"
  }
};
const _hoisted_33 = {
  style: {
    "width": "80%",
    "word-wrap": "break-word"
  }
};
const _hoisted_34 = {
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "flex-direction": "column"
  }
};
const _hoisted_35 = {
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "margin": "10px 0"
  }
};
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  key: 0,
  style: {
    "background": "rgb(245,247,250)",
    "width": "30px",
    "height": "30px",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "margin": "0 5px",
    "border-radius": "4px"
  }
};

const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-picture-outline",
  style: {
    "font-size": "14px",
    "color": "#d7d7d7"
  }
}, null, -1));

const _hoisted_39 = [_hoisted_38];
const _hoisted_40 = {
  key: 1,
  style: {
    "display": "flex",
    "flex-wrap": "wrap"
  }
};
const _hoisted_41 = {
  key: 0,
  style: {
    "margin": "20px 0 0 10px",
    "color": "#D9001B",
    "display": "flex"
  }
};
const _hoisted_42 = {
  style: {
    "white-space": "nowrap",
    "margin-right": "20px"
  }
};
const _hoisted_43 = {
  style: {
    "width": "80%",
    "word-wrap": "break-word"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");

  const _component_el_divider = _resolveComponent("el-divider");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [$props.status && $props.status != '1' && $props.status != '5' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$props.status == '2' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 审核中 ")) : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.statusName), 1))], 64)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass($options.getClassByStatus($data.dataInfo.answerVo.checkStatus))
  }, _toDisplayString($data.dataInfo.answerVo.checkStatusName), 3))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass($data.dataInfo.isEssential ? 'star' : ''),
    style: {
      "font-weight": "bold",
      "margin-bottom": "10px",
      "font-size": "14px",
      "word-break": "break-all",
      "margin-right": "150px"
    }
  }, _toDisplayString($data.dataInfo.sortIndex) + "." + _toDisplayString($data.dataInfo.title || '标题'), 3), $props.isView ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$props.status ? (_openBlock(), _createElementBlock("div", _hoisted_5, [$data.dataInfo.answerVo.contentItemId && $data.dataInfo.answerVo.contentItemId != 'null' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [$props.isCheckBox ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selects, (item, key) => {
    return _openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(key), 1), !item.length ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)) : (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (imgItems, index) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [imgItems.imageUrl ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        class: "avatarPreview m_0_5",
        src: $options.replacePath(imgItems.imageUrl),
        "initial-index": index,
        "preview-src-list": $data.answerArrayCheckBox[key],
        style: {
          "border-radius": "4px"
        },
        fit: "cover"
      }, null, 8, ["src", "initial-index", "preview-src-list"])) : _createCommentVNode("", true)], 64);
    }), 256))]))]);
  }), 256))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString($data.select), 1), !$data.answerImgView.length ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18)) : (_openBlock(), _createElementBlock("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.answerImgView, (imgItems, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [imgItems.imageUrl ? (_openBlock(), _createBlock(_component_el_image, {
      key: 0,
      class: "avatarPreview m_0_5",
      src: imgItems.imageUrl,
      "preview-src-list": $data.answerArray,
      "initial-index": index,
      style: {
        "border-radius": "4px"
      },
      fit: "cover"
    }, null, 8, ["src", "preview-src-list", "initial-index"])) : _createCommentVNode("", true)], 64);
  }), 256))]))]))])) : $props.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 用户未填报 ")) : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($props.damageRTextL.userHasNotFilledOut), 1))])) : _createCommentVNode("", true), !$props.status && $props.isAdmin ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataInfo.itemList, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", {
      class: _normalizeClass($props.isCheckBox ? [$data.selectsIndex[index] ? 'optionSelect' : 'option'] : [$data.selectIndex === item.id ? 'optionSelect' : 'option']),
      style: {
        "line-height": "28px",
        "cursor": "pointer",
        "word-break": "break-all",
        "text-align": "left"
      }
    }, _toDisplayString(item.optionName), 3), !item.damageReportContentItemImageList.length || !item.damageReportContentItemImageList[0] ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)) : (_openBlock(), _createElementBlock("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.damageReportContentItemImageList, (imgItems, index) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [imgItems.imageUrl ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        class: "avatarPreview m_0_5",
        src: $options.replacePath(imgItems.imageUrl),
        "initial-index": index,
        "preview-src-list": $data.imgArray[item.id],
        style: {
          "border-radius": "4px"
        },
        fit: "cover"
      }, null, 8, ["src", "initial-index", "preview-src-list"])) : _createCommentVNode("", true)], 64);
    }), 256))]))]);
  }), 256))])])) : _createCommentVNode("", true), $data.dataInfo.answerVo?.checkStatus === '1' && $props.status != '2' ? (_openBlock(), _createElementBlock("div", _hoisted_29, [$props.isAdmin ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_30, _createElementVNode("div", _hoisted_31, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_32, _toDisplayString($props.damageRTextL.additionalRemarks) + ": ", 1), _createElementVNode("div", _hoisted_33, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)], 64))])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataInfo.itemList, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", {
      class: _normalizeClass($props.isCheckBox ? [$data.selectsIndex[index] ? 'optionSelect' : 'option'] : [$data.selectIndex === item.id ? 'optionSelect' : 'option']),
      style: {
        "line-height": "28px",
        "cursor": "pointer",
        "word-break": "break-all",
        "text-align": "left"
      },
      onClick: $event => $options.clickOption(index, item)
    }, _toDisplayString(item.optionName), 11, _hoisted_36), !item.damageReportContentItemImageList.length || !item.damageReportContentItemImageList[0] ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39)) : (_openBlock(), _createElementBlock("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.damageReportContentItemImageList, (imgItems, index) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [imgItems.imageUrl ? (_openBlock(), _createBlock(_component_el_image, {
        key: 0,
        class: "avatarPreview m_0_5",
        src: $options.replacePath(imgItems.imageUrl),
        "initial-index": index,
        "preview-src-list": $data.imgArray[item.id],
        style: {
          "border-radius": "4px"
        },
        fit: "cover"
      }, null, 8, ["src", "initial-index", "preview-src-list"])) : _createCommentVNode("", true)], 64);
    }), 256))]))]);
  }), 256))]), $data.dataInfo.answerVo?.checkStatus === '1' && $props.status != '2' ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString($props.damageRTextL.additionalRemarks) + ": ", 1), _createElementVNode("div", _hoisted_43, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)])) : _createCommentVNode("", true)], 64))]), _createVNode(_component_el_divider), _renderSlot(_ctx.$slots, "default", {
    data: this
  }, undefined, true)]);
}